export const LOGIN_METHODS = {
    PASSPORT: "passport",
    EMAIL: "email",
    GUESTID: "guestId"
} as const;

export type LoginMethod =
    (typeof LOGIN_METHODS)[keyof typeof LOGIN_METHODS];